import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  Alert,
  AlertTitle,
} from '@mui/material';
import { EmailOutlined, InfoOutlined } from '@mui/icons-material';

interface EmailConfirmationPendingProps {
  email: string;
  onBackToLogin?: () => void;
}

export const EmailConfirmationPending: React.FC<EmailConfirmationPendingProps> = ({
  email,
  onBackToLogin,
}) => {
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <EmailOutlined sx={{ fontSize: 64, color: 'primary.main' }} />
        </Box>
        
        <Typography variant="h5" gutterBottom>
          確認メールを送信しました
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          <strong>{email}</strong> にメールを送信しました。
        </Typography>

        <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
          <AlertTitle>次のステップ</AlertTitle>
          <Box component="ol" sx={{ pl: 2, mb: 0 }}>
            <li>受信箱をご確認ください</li>
            <li>メール内の「確認」ボタンをクリックしてください</li>
            <li>アカウントの登録が完了します</li>
          </Box>
        </Alert>

        <Alert severity="warning" sx={{ mb: 3, textAlign: 'left' }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
            <InfoOutlined sx={{ mr: 1, mt: 0.5 }} />
            <Box>
              <Typography variant="body2" sx={{ mb: 1 }}>
                メールが届かない場合：
              </Typography>
              <Box component="ul" sx={{ pl: 2, mb: 0, mt: 0 }}>
                <li>迷惑メールフォルダをご確認ください</li>
                <li>メールアドレスが正しいかご確認ください</li>
                <li>数分待ってから再度ご確認ください</li>
              </Box>
            </Box>
          </Box>
        </Alert>

        {onBackToLogin && (
          <Button
            variant="outlined"
            onClick={onBackToLogin}
            fullWidth
            sx={{ mt: 2 }}
          >
            ログイン画面に戻る
          </Button>
        )}
      </Paper>
    </Container>
  );
};